import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";

const DetailModal = ({ open, onClose, data }) => {
  if (!data) return null;

  const InfoItem = ({ label, value }) => (
    <Grid item xs={12} sm={6}>
      <Typography variant="body2">
        <strong>{label}:</strong> {Array.isArray(value) ? value.join(", ") : value || "N/A"}
      </Typography>
    </Grid>
  );

  return (
    <Box
      sx={{
        display: open ? "flex" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          backgroundColor: "#fff",
          padding: 4,
          borderRadius: 2,
          width: "85%",
          maxHeight: "85vh",
          overflowY: "auto",
        }}
      >
        <MDTypography variant="h6" mb={2}>
          RSA User Applicant Details
        </MDTypography>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section A — Personal & Contact Information
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Full Name" value={data.fullName} />
            <InfoItem label="Gender" value={data.gender} />
            <InfoItem label="Date of Birth" value={data.dob} />
            <InfoItem label="Email" value={data.email} />
            <InfoItem label="Mobile" value={data.mobile} />
            <InfoItem label="Next of Kin" value={data.nextOfKin} />
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section B — Service Background
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Applicant Type" value={data.applicantType} />
            <InfoItem label="Years of Service" value={data.yearsOfService} />
            <InfoItem label="Service Number" value={data.serviceNumber} />
            <InfoItem label="NIN" value={data.nin} />
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section C — Coverage Area for Wellbeing Checks
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Community" value={data.community} />
            <InfoItem label="LGA" value={data.lga} />
            <InfoItem label="State" value={data.state} />
            <InfoItem label="Coverage State" value={data.coverageState} />
            <InfoItem label="Nearest Police Station" value={data.nearestPoliceStation} />
            <InfoItem label="Address" value={data.address} />
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section D — Availability & Mobility
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Availability" value={data.availability} />
            <InfoItem label="Daily Time" value={data.dailyTime} />
            <InfoItem label="Mobility" value={data.mobility} />
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section E — Bank Details (for stipend)
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Bank Name" value={data.bankName} />
            <InfoItem label="Account Name" value={data.accountName} />
            <InfoItem label="Account Number" value={data.accountNumber} />
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section F — Attachments
          </Typography>
          <Grid container spacing={2}>
            {data.proofUrl && (
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" fontWeight="bold" gutterBottom>
                  Proof Image:
                </Typography>
                <img
                  src={data.proofUrl}
                  alt="Proof"
                  style={{ width: "100%", maxHeight: "200px", objectFit: "cover", borderRadius: 4 }}
                />
              </Grid>
            )}

            {data.selfieUrl && (
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" fontWeight="bold" gutterBottom>
                  Selfie Image:
                </Typography>
                <img
                  src={data.selfieUrl}
                  alt="Selfie"
                  style={{ width: "100%", maxHeight: "200px", objectFit: "cover", borderRadius: 4 }}
                />
              </Grid>
            )}

            {data.locationUrl && (
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" fontWeight="bold" gutterBottom>
                  Location Image:
                </Typography>
                <img
                  src={data.locationUrl}
                  alt="Location"
                  style={{ width: "100%", maxHeight: "200px", objectFit: "cover", borderRadius: 4 }}
                />
              </Grid>
            )}
          </Grid>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Section G — Declarations & Consents
          </Typography>
          <Grid container spacing={2}>
            <InfoItem label="Declaration 1" value={data.declaration1 ? "Agreed" : "Not Agreed"} />
            <InfoItem label="Declaration 2" value={data.declaration2 ? "Agreed" : "Not Agreed"} />
            <InfoItem label="Declaration 3" value={data.declaration3 ? "Agreed" : "Not Agreed"} />
            <InfoItem label="Declaration 4" value={data.declaration4 ? "Agreed" : "Not Agreed"} />
          </Grid>
        </Box>

        <Box mt={4} textAlign="right">
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </Box>
      </Box>
    </Box>
  );
};

export default DetailModal;
